// Example:
// Input:  YYYY-MM-DD
// Output: DD/MM/YYYY
export const formatDateForDisplay = (str: string): string => {
  return str.split('-').reverse().join('/');
};

export const preserveNewLines = (str: string): string => {
  return str ? str.replace(/(?:\\r\\n|\\r|\\n)/g, '<br/>') :  str;
};

export const toISODateString = (date: Date): string => {
  const pad = (n: number): string => {
    if (n < 10) {
      return '0' + n;
    } else {
      return '' + n;
    }
  };

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  return [year, month, day].join('-');
};

export const formatConstantForDisplay = (str: string): string => {
  return str.split('_').join(' ');
};

export const rewriteISODates = (str: string): string => {
  if (!str) {
    return str;
  }

  const isoDateRegex = RegExp(/\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|[01])*/,'g');
  let match: any;

  while ((match = isoDateRegex.exec(str)) !== null) {
    str = str.replace(match[0], formatDateForDisplay(match[0]));
  }

  return str;
};

export const epochToDateDisplayString = (epoch: number): string => {
  return new Date(epoch).toLocaleDateString('en-au');
};

export const epochToDateTimeDisplayString = (epoch: number): string => {
  return new Date(epoch).toLocaleString('en-au');
};

export const iconForMimeType = (mimeType: string): string|null => {
  if (mimeType.match(/\/pdf$/)) {
    return "far fa-file-pdf digrep-file-icon";
  } else if (['audio/mpeg', 'audio/vorbis', 'audio/x-wav', 'audio/x-aiff'].indexOf(mimeType) >= 0) {
    return "far fa-file-audio digrep-file-icon";
  } else if (['video/mp4'].indexOf(mimeType) >= 0) {
    return "far fa-file-video digrep-file-icon";
  } else if (['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].indexOf(mimeType) >= 0) {
    return "far fa-file-word digrep-file-icon";
  } else if (['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].indexOf(mimeType) >= 0) {
    return "far fa-file-excel digrep-file-icon";
  } else if (['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'].indexOf(mimeType) >= 0) {
    return "far fa-file-powerpoint digrep-file-icon";
  } else if (mimeType === 'application/msaccess') {
    return "fas fa-database digrep-file-icon";
  } else if (mimeType === 'application/onenote') {
    return "fas fa-file-alt digrep-file-icon";
  } else if (['text/calendar', 'application/vnd.ms-outlook'].indexOf(mimeType) >= 0) {
    return "fas fa-envelope-open-text digrep-file-icon";
  } else if (mimeType === 'application/x-mspublisher') {
    return "far fa-newspaper digrep-file-icon";
  } else if (['image/png', 'image/jpeg', 'image/jp2', 'image/svg+xml', 'image/tiff', 'image/bmp'].indexOf(mimeType) >= 0) {
    return "far fa-file-image digrep-file-icon";
  }

  return null;
}
